enum typeEnum {
  JSON = 'json',
  IMAGE = 'image',
  MEDIA_GALLERY = 'media_gallery',
}

export default typeEnum;
